import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';

export default function SubscriptionSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchCurrentUser } = useAuthStore();

  useEffect(() => {
    // Refresh user data to get updated subscription status
    fetchCurrentUser();

    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/home');
    }, 5000);

    return () => clearTimeout(timer);
  }, [fetchCurrentUser, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-950 via-dark-900 to-dark-800 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8">
          {/* Success Icon */}
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center animate-bounce">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-white mb-4">
            {t('subscription.success.title', 'Welcome to Fonorex!')}
          </h1>

          <p className="text-gray-400 mb-8">
            {t('subscription.success.message', 'Your subscription is now active. Enjoy unlimited access to our music library.')}
          </p>

          <button
            onClick={() => navigate('/home')}
            className="w-full px-6 py-3 bg-gradient-to-r from-primary-500 to-secondary-500 hover:from-primary-600 hover:to-secondary-600 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-glow"
          >
            {t('subscription.success.cta', 'Start Listening')}
          </button>

          <p className="text-sm text-gray-500 mt-4">
            {t('subscription.success.redirect', 'Redirecting automatically in 5 seconds...')}
          </p>
        </div>
      </div>
    </div>
  );
}
